import React, { useState } from 'react';
import '../../stylesheets/jobsMuggle.scss';
import Button from '../../muiComponents/Button';
import { sanitizeHTMLBase } from '../../utils/sanitizeInjectedHTML';

export default function CardJobs({ job }) {
    const [show, setShow] = useState(false);

    return (
        <>
            <h2 className='jobs-title font-weight-b margin-bottom-8'>
                {job.Title}
            </h2>

            <div className='text-align-justify job jobs-report '>
                <span className='font-weight-b'>
                    Report to {job.ReportTo} - {job.Duration} - Ref.{' '}
                    {job.Reference}
                </span>
            </div>

            <div className='text-align-justify jobs-departament '>
                <span className='font-weight-b'>Department:</span>{' '}
                {job.Department}
            </div>

            <div className='text-align-justify jobs-location '>
                <span className='font-weight-b'>Location:</span> {job.Location}
            </div>

            <div
                className='text-align-justify jobs-short  margin-bottom10'
                dangerouslySetInnerHTML={{
                    __html: sanitizeHTMLBase(job.ShortDescription),
                }}
            />

            <Button
                type='button'
                variant='contained'
                onClick={() => setShow(!show)}
            >
                {show ? 'Close' : 'More details...'}
            </Button>

            {show && (
                <div className='job-details margin-top-16'>
                    <h3 className='jobs-title padding-bottom-8 font-weight-b margin-top-0'>
                        Main Responsibilities
                    </h3>
                    <div
                        className='text-align-justify'
                        dangerouslySetInnerHTML={{
                            __html: sanitizeHTMLBase(job.Functions),
                        }}
                    />

                    <h3 className='jobs-title padding-bottom-8 font-weight-b'>
                        Skills Required
                    </h3>
                    <div
                        className='text-align-justify'
                        dangerouslySetInnerHTML={{
                            __html: sanitizeHTMLBase(job.Skills),
                        }}
                    />

                    <h3 className='font-weight-b'>Experience Required</h3>
                    <div
                        className='text-align-justify'
                        dangerouslySetInnerHTML={{
                            __html: sanitizeHTMLBase(job.ExperienceRequired),
                        }}
                    />

                    <h5 className='jobs-title font-weight-b margin-block-8'>
                        Please apply by sending CV + cover letter to:
                    </h5>
                    <h5 className='jobs-title font-weight-b text-align-center'>
                        hr@fastpayhotels.com
                    </h5>
                </div>
            )}
        </>
    );
}
